import { useEffect } from "react";
import { useState } from "react";

export const useAttachments = () => {
    const [attachments, setAttachments] = useState([]);

    const handleFileSelect = (e) => {
        if (e.target.files) {
            const files = Array.from(e.target.files);
            const newAttachments = files.map(file => {
                let type = 'file';
                if (file.type.startsWith('image/')) type = 'image';
                else if (file.type.startsWith('video/')) type = 'video';
                else if (file.type.startsWith('audio/')) type = 'audio';

                return {
                    file,
                    url: URL.createObjectURL(file),
                    type,
                    name: file.name
                };
            });
            setAttachments(prev => [...prev, ...newAttachments]);
        }
    };

    useEffect(() => {
        return () => {
            attachments.forEach(att => URL.revokeObjectURL(att.url));
        };
    }, [attachments]);

    const removeAttachment = (index) => {
        const attachmentToRemove = attachments[index];
        if (attachmentToRemove) {
            URL.revokeObjectURL(attachmentToRemove.url);
        }
        setAttachments(prev => prev.filter((_, i) => i !== index));
    };

    const addAudioAttachment = (audioFile, audioUrl) => {
        setAttachments(prev => [...prev, {
            file: audioFile,
            url: audioUrl,
            type: 'audio',
            name: "Voice Message"
        }]);
    };

    const clearAttachments = () => {
        attachments.forEach(att => URL.revokeObjectURL(att.url));
        setAttachments([]);
    };

    return {
        attachments,
        handleFileSelect,
        removeAttachment,
        addAudioAttachment,
        clearAttachments
    };
};